import { CURRENCIES, useLocale } from '../../context/LocaleContext';

const LocaleSwitch = () => {
  const { lang, setLang, currency, setCurrency } = useLocale();

  return (
    <div className="flex items-center gap-2">
      <div className="lang-toggle" role="group" aria-label="Language">
        <button type="button" aria-pressed={lang === 'en'} onClick={() => setLang('en')}>EN</button>
        <button type="button" aria-pressed={lang === 'ar'} onClick={() => setLang('ar')}>عربي</button>
      </div>
      <select
        className="locale-select"
        dir="ltr"
        aria-label="Currency"
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
      >
        {CURRENCIES.map((item) => (
          <option key={item.code} value={item.code}>
            {item.code}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LocaleSwitch;
